import { render } from "./App.vue?vue&type=template&id=6789a565"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6789a565&lang=scss"

import exportComponent from "C:\\Users\\dlin\\Desktop\\work\\webportal-lms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__